import * as Sentry from "@sentry/react";

import { shouldEnableFeature } from "./shouldEnableFeature";

export function logToSentry(
	msg: string,
	severity?: "fatal" | "error" | "warning" | "log" | "debug" | "info",
	args: unknown[] = [],
) {
	const shouldLogToSentry = shouldEnableFeature("useSentry");

	if (shouldLogToSentry) {
		Sentry.captureMessage(msg, severity);
	} else {
		log(msg, severity, args);
	}
}

export function log(
	msg: string,
	severity?: "fatal" | "error" | "warning" | "log" | "debug" | "info",
	...args: unknown[]
) {
	if (severity === "error") {
		// eslint-disable-next-line no-console
		console.error(`[APP] [ERROR] ${msg}`, ...args);
	} else if (severity === "warning") {
		// eslint-disable-next-line no-console
		console.warn(`[APP] [WARNING] ${msg}`, ...args);
	} else if (severity === "info") {
		// eslint-disable-next-line no-console
		console.info(`[APP] [INFO] ${msg}`, ...args);
	} else {
		// eslint-disable-next-line no-console
		console.log(`[APP] ${msg}`, ...args);
	}
}
